import {FormControl, Grid, InputLabel, Typography} from "@material-ui/core";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import React, {useState} from "react";
import {Search} from "@material-ui/icons";
import PropTypes from "prop-types";
import {useSoglieFilterStyles} from "../../../../soglie-eventi/soglie/soglie-filter/SoglieFilterStyles";
import GrayHeaderCard from "../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import IconButton from "@material-ui/core/IconButton";
import {daAttivareFilterButtons} from "./DaAttivareFilterHelper";
import InlineRadioButtons from "../../../../../../ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";


const DaAttivareFilter = (props) => {
    const classes = useSoglieFilterStyles()
    const [searchText, setSearchText] = useState("")
    const [selectedRadioBtn, setSelectedRadioBtn] = useState(daAttivareFilterButtons[0].value)

    const title = (
        <Typography variant={"subtitle2"}>
            Ricerca
        </Typography>
    )

    const handleInputChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleEnterPressed = (e) => {
        if (e.which === 13)
            handleSearchIcon()
    }

    const handleSearchIcon = () => {
        if (searchText.length !== 0) {
            props.handleSearchIcon(selectedRadioBtn, searchText)
            setSearchText("");
        }
    }

    const handleRadioBtnChange = (e) => {
        setSelectedRadioBtn(e.target.value)
    }

    return (
        <>
            <GrayHeaderCard title={title}>

                    <Grid container
                          justifyContent="space-between"
                          alignItems="center">
                        <Grid item container
                              alignItems="center"
                              xs={12} sm={8} md={9}>
                            <FormControl fullWidth>
                                <InputLabel>Cerca</InputLabel>
                                <Input labelid="filterSearchLabel"
                                       type="search"
                                       autoComplete="off"
                                       onChange={handleInputChange}
                                       value={searchText}
                                       onKeyPress={handleEnterPressed}
                                       endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton onClick={handleSearchIcon}>
                                                   <Search/>
                                               </IconButton>
                                           </InputAdornment>
                                       }/>
                            </FormControl>

                            <Typography variant="subtitle2"
                                        display="inline"
                                        className={classes.typographyRadioButtons}
                                        color="textSecondary">
                                Cerca per
                            </Typography>

                            <InlineRadioButtons value={selectedRadioBtn}
                                                radioButtons={daAttivareFilterButtons}
                                                handleChange={handleRadioBtnChange}/>
                        </Grid>
                    </Grid>

            </GrayHeaderCard>

           </>
    )
}

DaAttivareFilter.propTypes = {
    handleSearchIcon: PropTypes.func.isRequired,
    handleSelectSearch: PropTypes.func.isRequired
}

export default DaAttivareFilter
